// extracted by mini-css-extract-plugin
export default {"cardContainer":"entityCard_cardContainer__a2-1n","imgTitle":"entityCard_imgTitle__RGAF6","imgStyle":"entityCard_imgStyle__Vk6-7"};